import React, { useEffect, useState } from "react";
import clsx from "clsx";

import { createPluggable } from "pluggable-react";
import Button from "../../common/Button/Button";
import styles from "./DevPanel.module.scss";

export interface DevPanelProps {
    children?: React.ReactNode;
    className?: string;
}

const DefaultDevPanel: React.FC<DevPanelProps> = ({ children, className }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Only enable in development mode
        if (process.env.NODE_ENV !== "development") {
            return;
        }

        const handleKeyDown = (event: KeyboardEvent) => {
            // Check for Ctrl+D (or Cmd+D on Mac)
            if ((event.ctrlKey || event.metaKey) && event.key === "d") {
                event.preventDefault();
                setIsVisible((prev) => !prev);
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    // Don't render anything in production
    if (process.env.NODE_ENV !== "development") {
        return null;
    }

    if (!isVisible) {
        return null;
    }

    return (
        <div className={clsx(styles.devPanel, className)} data-deci-dev-panel="true">
            <div className={styles.header}>
                <span className={styles.title}>Dev Panel</span>
                <Button
                    label="Close dev panel"
                    variant="ghost"
                    className={styles.closeButton}
                    onClick={() => setIsVisible(false)}
                    aria-label="Close dev panel"
                >
                    ×
                </Button>
            </div>
            <div className={styles.content}>{children}</div>
        </div>
    );
};

DefaultDevPanel.displayName = "DevPanel";

const DevPanel = createPluggable<DevPanelProps>("deci.devPanel", DefaultDevPanel);

export default DevPanel;

